<form class="form" [formGroup]="model">
  @if (this.listMetaData && this.listMetaData.length > 0 && !this.isLoading) {
    <div>
      <div class="title-header">
        <h1>Dados Adicionais</h1>
      </div>
      <div class="row">
        @for (item of listMetaData; track item) {
          <div class="col-12 col-sm-6 col-md-4">
            @if (item.metaData.idMetaDataType == metaDataTypeEnumResult.Texto) {
              <mat-form-field
                appearance="outline">
                <mat-label>{{item.metaData.metaDataName}}</mat-label>
                <input matInput [readonly]="this.isReadonly" formControlName="{{item.metaData.idMetaData}}"
                  type="text">
                </mat-form-field>
              }
              @if (item.metaData.idMetaDataType == metaDataTypeEnumResult.Numero) {
                <mat-form-field
                  appearance="outline">
                  <mat-label>{{item.metaData.metaDataName}}</mat-label>
                  <input matInput [readonly]="this.isReadonly" formControlName="{{item.metaData.idMetaData}}"
                    type="number">
                  </mat-form-field>
                }
                @if (item.metaData.idMetaDataType == metaDataTypeEnumResult.Data) {
                  <mat-form-field
                    appearance="outline">
                    <mat-label>{{item.metaData.metaDataName}}</mat-label>
                    <input matInput inputmode="text" type="text" [mask]="masks.date" placeholder="dd/mm/aaaa"
                      [readonly]="this.isReadonly" [formControlName]="item.metaData.idMetaData"
                      (change)="verifyDate(item.metaData.idMetaData)">
                      @if (model.get(item.metaData.idMetaData.toString()).hasError('invalidDate')) {
                        <mat-error>Data
                        inválida</mat-error>
                      }
                    </mat-form-field>
                  }
                  @if (item.metaData.idMetaDataType == metaDataTypeEnumResult.Select) {
                    <mat-form-field
                      appearance="outline">
                      <mat-label>{{item.metaData.metaDataName}}</mat-label>
                      <input matInput formControlName="{{item.metaData.idMetaData}}" [readonly]="this.isReadonly">
                    </mat-form-field>
                  }
                </div>
              }
            </div>
          </div>
        }
      </form>